







































































import {Component} from '@/shared/component';
import {Transporteur} from '@/models';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';

import storeTransporteur from '@/stores/modules/transporteur';

import CrudFournisseurShow from '@/components/Crud/Fournisseur/Show.vue';
import CrudFournisseurEdit from '@/components/Crud/Fournisseur/Edit.vue';

@Component({
	components: {
		CrudFournisseurShow,
		CrudFournisseurEdit,
	}
})
export default class CrudTransporteurShow extends AbstractShowVue<Transporteur> {
	public constructor() {
		super(storeTransporteur);
	}
}
